<script lang="ts">
  import { theme } from '@shared/ui/theme';
  import { cn } from '@shared/utils';
</script>

<div
  class="{cn('relative flex items-center justify-center py-4', {
    light: $theme === 'light' || !$theme,
    dark: $theme === 'dark',
  })}"
>
  <div class="dot-falling"></div>
</div>

<style lang="scss">
  @mixin dot-falling($color, $name) {
    .dot-falling {
      position: relative;
      left: -9999px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: $color;
      color: $color;
      box-shadow: 9999px 0 0 0 $color;
      animation: dot-falling-#{$name} 1s infinite linear;
      animation-delay: 0.1s;

      &::before,
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: $color;
        color: $color;
      }

      &::before {
        box-shadow: 9984px 0 0 0 $color;
        animation: dot-falling-before-#{$name} 1s infinite linear;
        animation-delay: 0s;
      }

      &::after {
        box-shadow: 10014px 0 0 0 $color;
        animation: dot-falling-after-#{$name} 1s infinite linear;
        animation-delay: 0.2s;
      }
    }

    @keyframes dot-falling-#{$name} {
      0% {
        box-shadow: 9999px -15px 0 0 rgba(152, 128, 255, 0);
      }
      25%,
      50%,
      75% {
        box-shadow: 9999px 0 0 0 $color;
      }
      100% {
        box-shadow: 9999px 15px 0 0 rgba(152, 128, 255, 0);
      }
    }

    @keyframes dot-falling-before-#{$name} {
      0% {
        box-shadow: 9984px -15px 0 0 rgba(152, 128, 255, 0);
      }
      25%,
      50%,
      75% {
        box-shadow: 9984px 0 0 0 $color;
      }
      100% {
        box-shadow: 9984px 15px 0 0 rgba(152, 128, 255, 0);
      }
    }

    @keyframes dot-falling-after-#{$name} {
      0% {
        box-shadow: 10014px -15px 0 0 rgba(152, 128, 255, 0);
      }
      25%,
      50%,
      75% {
        box-shadow: 10014px 0 0 0 $color;
      }
      100% {
        box-shadow: 10014px 15px 0 0 rgba(152, 128, 255, 0);
      }
    }
  }

  .dark {
    @include dot-falling(#d9d9d9, 'dark');
  }

  .light {
    @include dot-falling(#393939, 'light');
  }
</style>
